import _ = require("lodash");
import { CellType, ExcelColorValue } from "../../util/UIConstants";
import { IColumnConfig } from "../configuration";
import { currentResource, labels } from "../../util/utils";

export class ClientRequestReferenceConfig implements IColumnConfig {
  columns: any[];
  constructor() {
    this.columns = [
      {
        CellHeader: "updateEyCanvas",
        CellHeaderResourceName: "clientrequestRefSheetMainHeaders",
        headerRangeStartIndex: 0,
        headerRangeLastIndex: 0,
        CellType: CellType.Protected,
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          HeaderBackgroundColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Center",
        },
        subColumns: [],
        hasNoSubHeaders: true,
      },
      {
        CellHeader: "priority",
        CellHeaderResourceName: "clientrequestRefSheetMainHeaders",
        headerRangeStartIndex: 2,
        headerRangeLastIndex: 3,
        IdColumnIndex: 3,
        valueColumnIndex: 2,
        cellId: "priority",
        CellType: CellType.Protected,
        cellToBindDropDown: true,
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          HeaderBackgroundColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Center",
        },
        isPriorityHeader: true,
        subColumns: [
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.priority.priorityName,
            CellDisplayIndex: 2,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.priorityTypeName;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.priority.priorityTypeId,
            CellDisplayIndex: 3,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.priorityTypeId;
            },
          },
        ],
      },
      {
        CellHeader: "assignedToGroups",
        CellHeaderResourceName: "clientrequestRefSheetMainHeaders",
        headerRangeStartIndex: 5,
        headerRangeLastIndex: 6,
        IdColumnIndex: 6,
        valueColumnIndex: 5,
        cellId: "assignedToGroups",
        CellType: CellType.Protected,
        adjustColumnWidth: true,
        cellToBindDropDown: true,
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          HeaderBackgroundColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Center",
        },
        isGroupsHeader: true,
        subColumns: [
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.assignedToGroups.groupName,
            CellDisplayIndex: 5,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
              columnWidth: 139,
            },
            getCellData: (data) => {
              return data.groupName;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.assignedToGroups.groupId,
            CellDisplayIndex: 6,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.groupId;
            },
          },
        ],
      },
      {
        CellHeader: "assignedToUsers",
        CellHeaderResourceName: "clientrequestRefSheetMainHeaders",
        headerRangeStartIndex: 8,
        headerRangeLastIndex: 12,
        parentColumnIndex: 12,
        IdColumnIndex: 11,
        valueColumnIndex: 8,
        cellId: "assignedToUsers",
        CellType: CellType.Protected,
        adjustColumnWidth: true,
        cellToBindDropDown: true,
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          HeaderBackgroundColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Center",
        },
        isExternalUsers: true,
        subColumns: [
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.assignedToUsers.groupMember,
            CellDisplayIndex: 8,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
              columnWidth: 277,
            },
            getCellData: (data) => {
              return data.groupMember;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.assignedToUsers.name,
            CellDisplayIndex: 9,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
              columnWidth: 139,
            },
            getCellData: (data) => {
              return data.name;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.assignedToUsers.groupName,
            CellDisplayIndex: 10,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
              columnWidth: 139,
            },
            getCellData: (data) => {
              return data.groupName;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.assignedToUsers.userId,
            CellDisplayIndex: 11,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.userId;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.assignedToUsers.groupId,
            CellDisplayIndex: 12,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.groupId;
            },
          },
        ],
      },
      {
        CellHeader: "eyContacts",
        CellHeaderResourceName: "clientrequestRefSheetMainHeaders",
        headerRangeStartIndex: 14,
        headerRangeLastIndex: 15,
        IdColumnIndex: 15,
        valueColumnIndex: 14,
        cellId: "eyContacts",
        CellType: CellType.Protected,
        adjustColumnWidth: true,
        cellToBindDropDown: true,
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          HeaderBackgroundColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Center",
        },
        isInternalUsers: true,
        subColumns: [
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.eyContacts.name,
            CellDisplayIndex: 14,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
              // columnWidth: 139,
            },
            getCellData: (data) => {
              return data.name;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.eyContacts.userId,
            CellDisplayIndex: 15,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.userId;
            },
          },
        ],
      },
      {
        CellHeader: "tags",
        CellHeaderResourceName: "clientrequestRefSheetMainHeaders",
        headerRangeStartIndex: 17,
        headerRangeLastIndex: 20,
        IdColumnIndex: 20,
        valueColumnIndex: 17,
        cellId: "tags",
        CellType: CellType.Protected,
        adjustColumnWidth: true,
        cellToBindDropDown: true,
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          HeaderBackgroundColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Center",
        },
        isTagsHeader: true,
        subColumns: [
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.tags.tagName,
            CellDisplayIndex: 17,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.tagName;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.tags.colorCode,
            CellDisplayIndex: 18,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.colorCode;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.tags.engagementTagName,
            CellDisplayIndex: 19,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
              columnWidth: 139,
            },
            getCellData: (data) => {
              return data.engagementTagName;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.tags.engagementTagID,
            CellDisplayIndex: 20,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.tagId;
            },
          },
        ],
      },
      {
        CellHeader: "timephases",
        CellHeaderResourceName: "clientrequestRefSheetMainHeaders",
        headerRangeStartIndex: 22,
        headerRangeLastIndex: 25,
        IdColumnIndex: 25,
        valueColumnIndex: 22,
        startDateIndex: 23,
        endDateIndex: 24,
        cellId: "timephases",
        CellType: CellType.Protected,
        adjustColumnWidth: true,
        cellToBindDropDown: true,
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          HeaderBackgroundColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Center",
        },
        isTimePhasesHeader: true,
        subColumns: [
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.timephases.periodName,
            CellDisplayIndex: 22,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
              columnWidth: 277,
            },
            getCellData: (data) => {
              return data.timePhase;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.timephases.startDate,
            CellDisplayIndex: 23,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.startDate;
            },
          },
          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.timephases.dueDate,
            CellDisplayIndex: 24,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.dueDate;
            },
          },

          {
            CellHeader: currentResource.clientrequestRefSheetSubHeaders.timephases.timephaseId,
            CellDisplayIndex: 25,
            CellType: CellType.Protected,
            CellFormat: {
              locked: true,
              HeaderFillColor: ExcelColorValue.Black,
              RowsFillColor: ExcelColorValue.GrayColor,
              horizontalAlignment: "Left",
              disableDefaultFormatting: true,
            },
            getCellData: (data) => {
              return data.timePhaseId;
            },
          },
        ],
      },
    ];
  }
}
